import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import history from 'helpers/history';
import App from 'modules/App';
import { useAction } from 'hooks';
import { AppContext } from 'context';
import { SIGN_UP_FORM } from '../../../constants';
export const useSignUpSteps = (allowedScopeNames, returnUrl)=>{
    const { getUrl } = useContext(AppContext);
    const isIntegrationProcess = useSelector(App.selectors.isIntegrationProcess);
    const onSetFormValue = useAction(App.actions.setFormValue, SIGN_UP_FORM);
    const signInUrl = isIntegrationProcess && returnUrl ? `${getUrl('sign-in')}?ReturnUrl=${encodeURIComponent(returnUrl)}` : getUrl('sign-in');
    const isPredefinedScope = allowedScopeNames.length === 1;
    const defaultFirstStep = isPredefinedScope ? 'UserInfo' : 'ChooseScope';
    const [currentViewName, setCurrentViewName] = useState(defaultFirstStep);
    const [nextStep, setNextStep] = useState(null);
    const [prevStep, setPrevStep] = useState(null);
    const getNextStep = ()=>{
        switch(currentViewName){
            case 'ChooseScope':
                if (isPredefinedScope) {
                    onSetFormValue({
                        id: 'scope',
                        value: allowedScopeNames[0]
                    });
                    return 'FillData';
                }
                return 'UserInfo';
            case 'UserInfo':
                return 'FillData';
            default:
                return null;
        }
    };
    const getPreviousStep = ()=>{
        switch(currentViewName){
            case 'ChooseScope':
                return null;
            case 'UserInfo':
                return allowedScopeNames.length === 1 ? null : 'ChooseScope';
            case 'FillData':
                return 'UserInfo';
            default:
                return null;
        }
    };
    useEffect(()=>{
        setNextStep(getNextStep());
        setPrevStep(getPreviousStep());
    }, [
        currentViewName
    ]);
    const onContinue = ()=>{
        if (nextStep) {
            setCurrentViewName(nextStep);
        }
    };
    const onBack = ()=>{
        if (prevStep) {
            setCurrentViewName(prevStep);
        } else {
            history.push(signInUrl);
        }
    };
    const setConfirmEmail = ()=>setCurrentViewName('ConfirmEmail');
    const setDefaultFirstStep = ()=>setCurrentViewName(defaultFirstStep);
    return {
        currentViewName,
        onContinue,
        onBack,
        setConfirmEmail,
        setDefaultFirstStep
    };
};
export default useSignUpSteps;
